<template>
  <div v-if="showTools" class="checklists__tools-box">
    <div class="checklists__tools-box__wrapper">
      <!-- active, inactive -->
      <AppButtonIcon
        v-if="isCardActive && !compact"
        :title="statusOptions.title"
        :icon="statusOptions.icon"
        class="checklists__tools-box__button checklists__tools-box__button--status"
        :class="statusOptions.class"
        data-action="status"
        @click="actionRequested"
        @mouseover="changeIcon"
        @mouseleave="changeIcon"
      />
      <!-- edit -->
      <AppButtonIcon
        title="Editar"
        icon="far fa-edit"
        class="checklists__tools-box__button checklists__tools-box__button--edit"
        data-action="edit"
        @click="actionRequested"
      />
      <!-- delete -->
      <AppButtonIcon
        v-if="isEditable || !isTemplatePage || !isCardInactive"
        title="Eliminar"
        icon="far fa-trash-alt"
        class="checklists__tools-box__button checklists__tools-box__button--delete"
        :class="deleteOptions.class"
        @click="toggleWarning"
        v-on-clickaway="hideWarning"
      >
        <AppTooltipBalloon :show="showDeleteWarning" arrow-direction="down">
          <div
            class="checklists__tools-box__button-warn"
            data-action="delete"
            @click="actionRequested"
          >
            Eliminar
          </div>
        </AppTooltipBalloon>
      </AppButtonIcon>
    </div>
  </div>
</template>

<script>
// Utilities
import PageControl from '../mixins/pageControl'
import { mixin as clickaway } from 'vue-clickaway'
// Components
import AppButtonIcon from 'Ui/AppButtonIcon'
import AppTooltipBalloon from 'Ui/AppTooltipBalloon'

export default {
  name: 'ChecklistsToolsMenu',

  components: {
    AppButtonIcon,
    AppTooltipBalloon,
  },

  props: {
    showTools: {
      type: Boolean,
      default: false,
    },

    isVisible: {
      type: Boolean,
      default: false,
    },

    isActive: {
      type: Boolean,
      default: false,
    },

    compact: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [clickaway, PageControl],

  data() {
    return {
      swapIcon: false,
      showDeleteWarning: false,
    }
  },

  methods: {
    changeIcon() {
      this.swapIcon = !this.swapIcon
    },

    toggleWarning() {
      this.showDeleteWarning = !this.showDeleteWarning
    },

    hideWarning() {
      this.showDeleteWarning = false
    },

    async actionRequested(event) {
      const actionType = event.target.dataset.action
      actionType === 'delete' && this.hideWarning()
      await this.$nextTick()
      this.$emit('actionRequested', actionType)
    },
  },

  computed: {
    statusOptions() {
      const lockIcon = 'far fa-lock-alt'
      const unlockIcon = 'far fa-unlock-alt'
      return {
        class: this.isActive ? 'active' : '',
        title: this.isActive ? 'Desactivar' : 'Activar',
        icon:
          !this.isActive && !this.swapIcon
            ? lockIcon
            : this.isActive && this.swapIcon
            ? lockIcon
            : unlockIcon,
      }
    },

    visibilityOption() {
      return {
        title: this.isVisible ? 'Ocultar' : 'Mostar',
        icon: this.isVisible ? 'fas fa-chevron-down' : 'fas fa-chevron-right',
      }
    },

    deleteOptions() {
      return {
        class: this.showDeleteWarning ? '--warning' : '',
      }
    },

    isCardActive() {
      if (this.isTemplatePage) return true
      return this.$store.state.cards.currentCard.status === 'active'
    },
  },

  watch: {
    showTools(isVisible) {
      !isVisible && this.hideWarning()
    },
  },
}
</script>

<style scoped>
.checklists__tools-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  font-size: 12px;
  line-height: 18px;
  padding: 0;
  border-radius: 3px;
  background: linear-gradient(90deg, rgba(244, 244, 249, 1) 0%, rgba(231, 231, 243, 1) 15%);
}

.checklists__tools-box__wrapper {
  display: flex;
  height: 100%;
  z-index: 1;
}

.checklists__tools-box .checklists__tools-box__button {
  position: relative;
  height: 100%;
  width: 35px;
  border-radius: 0px;
  background-color: var(--c-secondary-400);
}

.checklists__tools-box__button >>> .app-icon {
  font-size: 13px;
}

.checklists__tools-box__wrapper > :last-child {
  border-radius: 0 3px 3px 0;
}

.checklists__tools-box__button.active {
  color: var(--c-secondary-800);
}

.checklists__tools-box__button--delete.--warning >>> .app-icon {
  color: var(--c-bright-red-500);
}

.checklists__tools-box__button--delete >>> .app-tooltip--balloon .app-tooltip--balloon-wrapper {
  padding: 4px 2px;
  background-color: var(--c-secondary-300);
  border: 1px solid var(--c-secondary);
}

.checklists__tools-box__button--delete >>> .app-tooltip--balloon .--arrow-down {
  bottom: -7px;
  width: 15px;
  height: 15px;
  border: 1px solid var(--c-secondary);
}

.checklists__tools-box .checklists__tools-box__button:hover {
  background-color: var(--c-secondary-500);
}

.checklists__tools-box__button-warn {
  font-weight: 600;
  color: var(--c-secondary-700);
  letter-spacing: 0.5px;
  border-radius: 2px;
  padding: 2px 6px;
}

.checklists__tools-box__button-warn:hover {
  background-color: var(--c-secondary-400);
}
</style>
